import { Accordian } from '@zet/design-system/accordian'
import { Stack } from '@zet/design-system/layout'

import FaqsWidget from './faqsWidget'

// TODO: Add types
interface ARNFAQsProps {
  brandComms: object
  item: object
  askCode: string
}

const ARNFAQs: React.FC<ARNFAQsProps> = ({ ...props }) => {
  const { brandComms, item, askCode } = props
  const FAQs = brandComms?.ARN?.faqs

  return (
    <Stack className="bg-white p-3">
      {FAQs?.map?.((faq) => (
        <Accordian
          title={faq.question}
          content={faq.answer}
          style={{
            width: '100%',
            marginTop: 0,
            marginBottom: 0,
          }}
          contentComponent={
            faq?.shareButtons ? (
              <FaqsWidget
                brandComms={brandComms}
                phone={item?.phoneNumber ? `+91 ${item?.phoneNumber}` : ''}
                shareButtonsConfig={faq?.shareButtons}
                item={item}
                askCode={askCode}
              />
            ) : null
          }
          isOpenInit={faq?.isOpen}
        />
      ))}
    </Stack>
  )
}

export default ARNFAQs
